import { render, staticRenderFns } from "./VehicleCategory.vue?vue&type=template&id=b0cafb0a&scoped=true&"
import script from "./VehicleCategory.vue?vue&type=script&lang=js&"
export * from "./VehicleCategory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b0cafb0a",
  null
  
)

export default component.exports